import res from './res'

res.add('kk', {
    selectionOptions: {
        all: 'Барлығын таңдау',
        none: 'Тазалау',
        invert: 'Төңкеру'
    }
})
